import customAxios from '../interceptors';

const deleteUser = (userID: string) => {
  return customAxios.delete(`${process.env.REACT_APP_API_URL}/users/${userID}`);
}

export default deleteUser;
